export default __webpack_public_path__ + "static/media/quality-good.a324f8b7.svg";